export function infiniteQueryKey<Key extends readonly unknown[]>(baseKey: Key) {
    return [...baseKey, 'infinite'] as const;
  }